var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar showSmallScreenOnly", class: _vm.navbarStyle },
    [
      _c(
        "div",
        {
          staticClass: "navbar-inner no-swipeback",
          class:
            { "navbar-inner-popup": !_vm.closePage && _vm.closePopup } +
            _vm.navbarInnerStyle,
          on: { click: _vm.closeCountryPickerModal },
        },
        [
          _c(
            "f7-nav-left",
            [
              true /*!backLink*/
                ? _c("f7-link", {
                    staticClass: "headbandTextColor",
                    attrs: {
                      "icon-fa": "bars",
                      "close-picker": "",
                      "open-panel": "left",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.navTitle
            ? _c("div", { staticClass: "titleApp centrageLogoSmallScreen" }, [
                _c(
                  "p",
                  {
                    class: { "streammind-icon-popup": _vm.closePopup },
                    on: {
                      click: function ($event) {
                        return _vm.goBackHome()
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "heritage-mobile-header",
                      attrs: { src: _vm.imgVarsLong, alt: "MoneyRoadBNPP" },
                    }),
                  ]
                ),
              ])
            : _c("div", { staticClass: "headbandTextColor" }, [
                _c("b", [_vm._v(_vm._s(_vm.navTitle))]),
              ]),
          _vm._v(" "),
          _vm.closePopup && !_vm.closePage
            ? _c(
                "div",
                { staticClass: "cancelButton" },
                [
                  _c(
                    "f7-link",
                    {
                      staticClass: "streammindContactListButton orangeFont",
                      attrs: { "close-popup": "" },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.cncl")))]
                  ),
                ],
                1
              )
            : _vm.closePage && !_vm.returnPreviousPage
            ? _c(
                "div",
                [
                  _c(
                    "f7-link",
                    {
                      staticClass:
                        "streammindContactListButton cancelButton orangeFont",
                    },
                    [_vm._v(_vm._s(_vm.$t("common.cncl")))]
                  ),
                ],
                1
              )
            : _vm.returnPreviousPage
            ? _c(
                "div",
                [
                  _c(
                    "f7-link",
                    {
                      staticClass:
                        "streammindContactListButton cancelButton orangeFont",
                    },
                    [_vm._v(_vm._s(_vm.$t("common.rtrn")))]
                  ),
                ],
                1
              )
            : _c("div", [_c("div", { staticClass: "mw-44px" })]),
          _vm._v(" "),
          _vm.subNavTitle !== "" && !_vm.closePage && _vm.closePopup
            ? _c(
                "f7-subnavbar",
                {
                  staticClass:
                    "subtitle-mobile-header subtitlePopup subnavbarPopup border-bottom-color-mobile-header",
                },
                [
                  !_vm.closePage && _vm.closePopup
                    ? _c("div", { staticClass: "subNavtitlePopup" }, [
                        _vm._v(_vm._s(_vm.subNavTitle)),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm.subNavTitle !== ""
            ? _c(
                "f7-subnavbar",
                {
                  staticClass:
                    "subtitle-mobile-header border-bottom-color-mobile-header",
                },
                [
                  _c(
                    "div",
                    { staticClass: "returnButtonMarginLeft" },
                    [
                      _vm.ReturnButton
                        ? _c(
                            "f7-link",
                            {
                              staticClass: "color-grey-mobile-header",
                              attrs: { "close-picker": "" },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-solid fa-play rotate-180deg",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "subNavtitle" }, [
                    _vm._v(_vm._s(_vm.subNavTitle)),
                  ]),
                  _vm._v(" "),
                  _vm.popoverName
                    ? _c(
                        "div",
                        { staticClass: "popoverNamePaddingRight" },
                        [
                          _c(
                            "f7-link",
                            {
                              staticClass:
                                "open-popover color-grey-mobile-header",
                              attrs: {
                                href: "#",
                                "data-popover": _vm.popoverName,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-duotone fa-square-question",
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c("div", [_c("div", { staticClass: "ml-15px" })]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }